<template>
    <div :id="sliderID" class="flex items-center space-x-3 w-full ">
        
        <splide 
            ref="splideRef"
            :class="$props.sliderClasses"             
            :slides="$props.slides" 
            :options="$props.options"            
            @splide:move="handleOnMove"
        >
            <splide-slide 
                v-for="(slide, index) in slides" 
                :key="`slide-${sliderID}-${index}`" 
                class="w-full"               
            >
                <router-link 
                    class="slide-container"
                    :title="slide.title"
                    :class="$props.containerClasses"  
                    :to="routeFor('detail', {slug: slide.title, pk: slide.id})"
                >
                    <img :class="$props.imageClasses" v-if="slide.cover_image" :src="slide.cover_image.max_size_src">                    
                    <img :class="$props.imageClasses" v-else :src="require('@/assets/images/no-image.jpg')">
                    <div 
                        v-if="$props.legendPosition == 'inside' && !$props.legendHidden" 
                        class="absolute left-0 bottom-0 w-full p-1 bg-brand bg-opacity-50 rounded-b-xl" 
                        :class="$props.legendClasses"
                    >
                        <h2 class="font-bold text-base xl:text-xl" :class="$props.headingClasses">{{slide.title}}</h2>
                    </div>
                </router-link>
            </splide-slide>
        </splide>                    
        
        <ul 
            v-if="$props.legendPosition != 'inside' && !$props.legendHidden" 
            class="outside-legends flex flex-col space-y-4" 
            :class="$props.legendContainerClasses"
        >                
            <li 
                v-for="(slide, index) in slides" 
                :key="`slide-${sliderID}-${index}`"                
                :class="{...computedLegendClasses, 'bg-gray-200': index == 0}"               
            >
                <router-link 
                    :to="routeFor('detail', {slug: slide.title, pk: slide.id})" 
                    :title="slide.title"
                    class="cursor-pointer flex items-center space-x-2"
                >
                    <div class="w-thumb h-thumb overflow-y-hidden rounded-lg">
                        <img 
                            :src="slide.cover_image.src" 
                            :alt="slide.cover_image.title" 
                            class="w-full rounded-lg"
                        >                        
                    </div>
                    <h2 
                        class="w-full font-bold text-base"
                        :class="{...computedHeadingClasses, 'text-brand': index == 0}"
                        @mouseover.prevent.stop="handleMoveOnHover(index)"
                    >{{ truncate(slide.title, 45) }}</h2>
                </router-link>
            </li>
        </ul>        
    </div>
</template>

<script>
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import { ref } from 'vue';
import randomstring from 'randomstring';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { routeFor, truncate } from '@/helpers'

export default {

    components: {
        Splide,
        SplideSlide
    },

    props: {
        slides: { type: Array, required: true },        
        options: { type: Object, default: () => {} },
        sliderClasses:  { type: String, default: 'w-2/4' },
        containerClasses: { type: String, default: 'rounded-xl' },
        imageClasses: { type: String, default: 'w-full h-auto border border-gray-100' },
        legendPosition: { type: String, default: 'right' },
        legendHidden: { type: Boolean, default: false },
        legendContainerClasses: { type: String, default: 'w-2/4' },
        legendClasses: { type: String, default: '' },
        headingClasses: { type: String, default: 'text-gray-500'},

        onMoved: { type: Function, default: () => {} }
    },

    setup (props) {
         
        const sliderID = props.sliderID || `slider-${randomstring.generate(5)}`
        const splideRef = ref(null)
        // const routeFor = routeFor

        const computedLegendClasses = {}
        props.legendClasses.split(' ').forEach(item => { computedLegendClasses[item] = true })

        const computedHeadingClasses = {}
        props.headingClasses.split(' ').forEach(item => { computedHeadingClasses[item] = true })

        function handleOnMove(splide, newIndex, oldIndex)
        {            
            const outsideLegends = document.querySelectorAll('#' + sliderID + ' .outside-legends li')  
            if(outsideLegends.length > 0)       
            {
                outsideLegends[oldIndex].classList.remove('bg-gray-200')
                outsideLegends[oldIndex].querySelector('a h2').classList.remove('text-brand')

                outsideLegends[newIndex].classList.add('bg-gray-200')
                outsideLegends[newIndex].querySelector('a h2').classList.add('text-brand')
            }
        }

        function handleMoveOnHover(index)
        { splideRef.value.go(index, false) }
        
        return {
            routeFor: routeFor,
            truncate: truncate,
            sliderID,
            splideRef,
            handleOnMove,
            handleMoveOnHover,
            computedLegendClasses,
            computedHeadingClasses
        }
    }
}
</script>

<style lang="css">

.splide__pagination__page .is-active {
    background: #005a86;
}

.h-thumb
{ height: 55px; }

.w-thumb
{ width: 150px; }

</style>